"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlotInteractionProviders = void 0;
const plot_state_factories_1 = require("./default-state-machine/plot-state-factories");
/**
 * @public
 * {@inheritDoc IPlotInteractionProviders}
 */
class PlotInteractionProviders {
    constructor(callbacks, eventTargets, attachPoint) {
        this.callbacks = callbacks;
        this.eventTargets = eventTargets;
        this.attachPoint = attachPoint;
        this.stateFactories = new plot_state_factories_1.PlotStateFactories();
    }
}
exports.PlotInteractionProviders = PlotInteractionProviders;
//# sourceMappingURL=plot-interaction-providers.js.map